import { useRef } from "react";
import { Button as AntdButton } from "antd";
import { PrinterOutlined, UserOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import FicheDeclarationSinistre from "../../../docs/FicheDeclarationSinistre";
import { frenchDate } from "../../../../../variables/functions";

// Historique des rédacteurs : rédacteur INITIAL (créateur, résolu côté serveur dans
// redacteurInitialNom depuis created_by) + MODIFICATEURS successifs (JSON append-only
// redacteursDeclaration = [{codeId, nom, date}]).
const parseModificateurs = (raw) => {
    if (!raw) return [];
    try {
        const arr = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(arr) ? arr : [];
    } catch (e) {
        return [];
    }
};

const FicheDeclarationTab = ({ sinistre }) => {
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({ content: () => printRef.current });

    if (!sinistre) {
        return null;
    }

    const redacteurInitial = sinistre.redacteurInitialNom || sinistre.createdBy || "—";
    const modificateursRaw = parseModificateurs(sinistre.redacteursDeclaration);
    // Repli par défaut : historique vide → dernière modification connue (updated_by / updated_at).
    const modificateurs = modificateursRaw.length
        ? modificateursRaw
        : ((sinistre.updatedAt && sinistre.updatedAt !== sinistre.createdAt && (sinistre.updatedByNom || sinistre.updatedBy))
            ? [{ nom: sinistre.updatedByNom || sinistre.updatedBy, date: sinistre.updatedAt }]
            : []);

    return (
        <div className="card-body">
            {/* Traçabilité rédaction : qui a pris la déclaration + qui l'a modifiée ensuite. */}
            <div style={{
                border: "1px solid #e8e8e8", borderRadius: 8, padding: "10px 14px",
                marginBottom: 12, background: "#fafafa", fontSize: 13,
            }}>
                <div>
                    <UserOutlined style={{ marginRight: 6, color: "#1677ff" }} />
                    <b>Déclaration prise par :</b> {redacteurInitial}
                    {sinistre.createdAt ? <> — le {frenchDate(sinistre.createdAt)}</> : null}
                </div>
                {modificateurs.length > 0 && (
                    <div style={{ marginTop: 6 }}>
                        <b>Modifications ultérieures :</b>
                        <ul style={{ margin: "4px 0 0", paddingLeft: 22 }}>
                            {modificateurs.map((m, i) => (
                                <li key={i}>
                                    {m?.nom || m?.codeId || "—"}
                                    {m?.date ? <> — le {frenchDate(m.date)}</> : null}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            <div className="container">
                <div className="grid-item">
                    <div id="ficheDeclarationSinistre">
                        <FicheDeclarationSinistre ref={printRef} sinistre={sinistre} />
                    </div>
                </div>
            </div>
            <br />
            <AntdButton
                onClick={handlePrint}
                type="primary"
                style={{ background: "green" }}
                icon={<PrinterOutlined />}
            >
                Imprimer
                <br />
                <br />
                <br />
            </AntdButton>
        </div>
    );
};

export default FicheDeclarationTab;
